export default {
  downloadReceipt: 'تحميل / طباعة',

  // States
  receiptNotFound: 'الإيصال غير موجود',
  receiptNotFoundDescription:
    'تعذر العثور على إيصال الدفع المطلوب. يرجى التواصل مع الدعم إذا كنت تعتقد أن هذا خطأ.',
  goToHome: 'العودة للرئيسية',
} as const
